import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button'

export const SecondaryButton = withStyles({
  root: {
    backgroundColor: "#FFA800",
    color: "white"
  }
})(Button);
